import {createSlice, createAsyncThunk} from '@reduxjs/toolkit'
import {
  onGetPagedAllProvinces,
  onCreateProvince,
  onDeleteProvince,
  onGetProvince,
  onUpdateProvince,
} from '../../../app/modules/base-definitions/components/provinces/core/_requests'
import {onGetCountries} from '../../../app/services/dataForComboBox/dataForComboBoxService'
interface ProvinceState {
  provinces: any
  province: any
  countries: any
  isLoading: boolean
}
const initialState = {
  provinces: [],
  province: null,
  countries: [],
  isLoading: true,
} as ProvinceState

export const fetchCountries = createAsyncThunk('province/fetchCountries', async () => {
  const data: any = await onGetCountries()

  return data.data.result.items
})

export const fetchProvinces = createAsyncThunk('province/fetchProvinces', async (param: any) => {
  const data: any = await onGetPagedAllProvinces(param)
  return data.data.result
})

export const fetchProvince = createAsyncThunk('province/fetchProvince', async (param: any) => {
  const data: any = await onGetProvince(param)
  return data.data.result
})

export const updateProvince = createAsyncThunk('province/updateProvince', async (param: any) => {
  const data: any = await onUpdateProvince(param)
  return data.data
})

export const createProvince = createAsyncThunk('province/createProvince', async (param: any) => {
  const data: any = await onCreateProvince(param)
  return data.data
})

export const deleteProvince = createAsyncThunk('province/deleteProvince', async (param: any) => {
  const data: any = await onDeleteProvince(param)
  return data.data
})

const provinceSlice = createSlice({
  name: 'province',
  initialState,
  reducers: {
    clearProvinces: (state) => {
      state.provinces = []
    },
    clearProvince: (state) => {
      state.province = null
    },
    activateLoading: (state) => {
      state.isLoading = true
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchProvinces.pending, (state: any) => {
      state.isLoading = true
    })
    builder.addCase(fetchProvinces.fulfilled, (state: any, action) => {
      state.provinces = action.payload
      state.isLoading = false
    })
    builder.addCase(fetchProvinces.rejected, (state: any) => {
      state.isLoading = false
    })
    builder.addCase(fetchProvince.fulfilled, (state: any, action) => {
      state.province = action.payload
    })
    builder.addCase(fetchCountries.fulfilled, (state: any, action) => {
      state.countries = action.payload
    })
  },
})

export const {clearProvinces, clearProvince, activateLoading} = provinceSlice.actions

export default provinceSlice.reducer
